import React from "react"
import { FlowChartContainer, Wrapper, Step } from "./styles"
import { ImArrowRight2, ImArrowDown2 } from "react-icons/im"

const FlowChart = ({ item }) => {
  const backgroundImage = item.customFields.backgroundImage.url
  return (
    <FlowChartContainer img={backgroundImage}>
      <Wrapper>
        <Step>
          <img
            src={item.customFields.step1Image.url}
            alt={item.customFields.step1Image.label}
          />
          <p>{item.customFields.step1Text}</p>
        </Step>
        <ImArrowRight2 className="arrow arrow-right" />
        <ImArrowDown2 className="arrow arrow-down" />
        <Step>
          <img
            src={item.customFields.step2Image.url}
            alt={item.customFields.step2Image.label}
          />
          <p>{item.customFields.step2Text}</p>
        </Step>
        <ImArrowRight2 className="arrow arrow-right" />
        <ImArrowDown2 className="arrow arrow-down" />
        <Step>
          <img
            src={item.customFields.step3Image.url}
            alt={item.customFields.step3Image.label}
          />
          <p>{item.customFields.step3Text}</p>
        </Step>
      </Wrapper>
    </FlowChartContainer>
  )
}

export default FlowChart
